import React from 'react';
import { Server } from '../../types';

interface UploadConfigModalProps {
  servers: Server[];
  uploadServerId: string;
  setUploadServerId: (uploadServerId: string) => void;
  uploadFileType: 'supervisor' | 'controller';
  setUploadFileType: (uploadFileType: 'supervisor' | 'controller') => void;
  uploadFile: File | null;
  setUploadFile: (uploadFile: File | null) => void;
  handleFileUpload: (e: React.FormEvent) => void;
  uploading: boolean;
}

const UploadConfigModal: React.FC<UploadConfigModalProps> = ({
  servers,
  uploadServerId,
  setUploadServerId,
  uploadFileType,
  setUploadFileType,
  uploadFile,
  setUploadFile,
  handleFileUpload,
  uploading
}) => {
  const handleServerIdChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setUploadServerId(e.target.value);
  };

  const handleFileTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setUploadFileType(e.target.value as 'supervisor' | 'controller');
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setUploadFile(e.target.files[0]);
    }
  };

  return (
    <form onSubmit={handleFileUpload} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Select Server
        </label>
        <select
          value={uploadServerId}
          onChange={handleServerIdChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        >
          <option value="">Choose a server...</option>
          {servers.filter(s => s.is_active).map(server => (
            <option key={server.id} value={server.id}>
              {server.name}
            </option>
          ))}
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          File Type
        </label>
        <select
          value={uploadFileType}
          onChange={handleFileTypeChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        >
          <option value="supervisor">Supervisor</option>
          <option value="controller">Controller</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Select File
        </label>
        <input
          type="file"
          accept=".json"
          onChange={handleFileChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />
        <p className="text-xs text-gray-500 mt-1">
          Upload supervisor.json or controller.json files
        </p>
        <div className="mt-2 p-3 bg-blue-50 rounded-md">
          <p className="text-xs text-blue-800 font-semibold mb-1">Expected JSON structure:</p>
          <div className="text-xs text-blue-700 space-y-1">
            <p><strong>supervisor.json:</strong> Must contain "user" and "supervisor" objects</p>
            <p><strong>controller.json:</strong> Must contain "user" object and "controllers" array</p>
            <p className="mt-1">The user object must have: id, username, and email fields</p>
          </div>
        </div>
      </div>
      
      <div className="flex justify-end gap-2">
        <button 
          type="submit" 
          className="btn btn-primary"
          disabled={uploading || !uploadFile || !uploadServerId}
        >
          {uploading ? 'Uploading...' : 'Upload'}
        </button>
      </div>
    </form>
  );
};

export default UploadConfigModal;